import React from 'react';
import Card from 'src/components/common/Card.redesign';
// import { ContextMenuAction } from 'src/components/common/ContextMenu';
import ContactNote from 'src/models/ContactNote';
import './OwnerPageStyles.scss';
import { ContextMenuAction } from 'src/components/common/ContextMenu';

interface IOwnerContactNoteCardProps {
    contactNote: ContactNote;
    isReadonly?: boolean;
    actions?: ContextMenuAction[];
    // attachedGlobalIds: Array<string>;

    onEditContactNote: (ownershipId: ContactNote) => void;
}

const OwnerContactNoteCard = (props: IOwnerContactNoteCardProps) => {
    // const actions: ContextMenuAction[] = [{ text: 'Edit Note', action: () => props.onEditContactNote(props.contactNote) }];
    const actions = () => {
        props.onEditContactNote(props.contactNote);
    };

    // const displayAttachedGlobalIds = () => {
    //     if (props.attachedGlobalIds.length > 0) {
    //         return (
    //             <div>
    //                 {props.attachedGlobalIds.map((globalId, index) => {
    //                     return (
    //                         <span key={index}>
    //                             {globalId}
    //                             {index < props.attachedGlobalIds.length - 1 ? ', ' : ''}
    //                         </span>
    //                     );
    //                 })}
    //             </div>
    //         );
    //     } else {
    //         return <span />;
    //     }
    // };

    return (
        <Card
            key={props.contactNote.id}
            badge={props.contactNote.id.toString()}
            // actions={actions}
            rightBadgePanel={`Last Modified: ${props.contactNote?.modifiedDate}`}
            onClick={!props.isReadonly ? actions : null}
            className="note-highlight"
            newContext={true}
            showMenu={true}
            contextActions={props.actions}
        >
            <div style={{ margin: '1rem' }}>
                <div>{props.contactNote.note}</div>
            </div>
        </Card>
    );
};

export default OwnerContactNoteCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/OwnerContactNoteCard.tsx